(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var path = window.location.pathname || '';

  if (lang.indexOf('en') !== 0 && path.indexOf('/en') !== 0) {
    return;
  }

  var replacements = {
    'Folge uns auf Instagram': 'Follow us on Instagram',
    'Schlaf ist mehr als Ruhe \u2013 er bestimmt, wie du dich f\u00fchlst. Folge P\u00cdUR f\u00fcr ruhige N\u00e4chte und bessere Morgen.': 'Sleep is more than rest - it shapes how you feel. Follow P\u00cdUR for calmer nights and better mornings.',
    'ZUM INSTAGRAM VON P\u00cdUR': 'FOLLOW P\u00cdUR ON INSTAGRAM',
    'Bleib mit P\u00cdUR verbunden': 'Stay Connected with P\u00cdUR',
    'Bleibe mit P\u00cdUR verbunden': 'Stay Connected with P\u00cdUR',
    'Heute: 3-f\u00fcr-2-Aktion': 'Today: 3-for-2 offer',
    'Lege 3 Produkte in den Warenkorb und erhalte 1 davon gratis! Mit dem Code:': 'Add 3 products to your cart and get 1 of them free! Use code:',
    'Super, du hast den Rabattcode kopiert!': 'Great, you copied the discount code!'
  };

  function translateTextNode(node) {
    var original = node.nodeValue;
    var trimmed = original.trim();
    var translated = replacements[trimmed];

    if (!translated) {
      return;
    }

    node.nodeValue = original.replace(trimmed, translated);
  }

  function translateElement(element) {
    var text = element.textContent ? element.textContent.trim().replace(/\s+/g, ' ') : '';
    var translated = replacements[text];

    if (translated && text.length < 220 && element.children.length <= 2) {
      element.textContent = translated;
    }

    ['aria-label', 'title', 'data-tooltip'].forEach(function (attribute) {
      var value = element.getAttribute(attribute);

      if (value && replacements[value.trim()]) {
        element.setAttribute(attribute, replacements[value.trim()]);
      }
    });
  }

  function translateTree(root) {
    if (!root) {
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) {
      translateElement(root);

      root.querySelectorAll('*').forEach(function (element) {
        translateElement(element);
      });
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;

        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var textNode = walker.nextNode();

    while (textNode) {
      translateTextNode(textNode);
      textNode = walker.nextNode();
    }
  }

  translateTree(document.body);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          translateTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          translateElement(node);
          translateTree(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
